export const listGetolo = {
  icon: {
    width: {
      sm: '1.5rem',
    },
    height: {
      sm: '1.5rem',
    },
    spacing: '0.75rem',
  },
  typography: {
    title: 'h3',
    text: 'body',
  },
};

export const listDaDirekt = {
  icon: {
    width: {
      sm: '1.5rem',
    },
    height: {
      sm: '1.5rem',
    },
    spacing: '1rem',
  },
  typography: {
    title: 'h3',
    text: 'body',
  },
};

export const listDaKaufland = {
  icon: {
    width: {
      sm: '2.063rem',
    },
    height: {
      sm: '2.063rem',
    },
    spacing: '0.5rem',
  },
  typography: {
    title: 'h4',
    text: 'p4',
  },
};

export const listFressnapf = {
  icon: {
    width: {
      sm: '1.375rem',
    },
    height: {
      sm: '1.375rem',
    },
    spacing: '1rem',
  },
  typography: {
    title: 'h3',
    text: 'body',
  },
};
